import React, { useState } from 'react';
import { signIn } from '../lib/auth';
import { supabase } from '../lib/supabase';

export default function Login({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
const handleForgotPassword = async () => {
    if (!email) {
      setError('Ingresa tu correo electrónico primero');
      return;
    }
    setLoading(true);
    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: 'https://milogiconnect.com/reset-password',
    });
    if (error) {
      setError(error.message);
    } else {
      setError('');
      alert('Te enviamos un correo para restablecer tu contraseña');
    }
    setLoading(false);
  };
  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    const { data, error } = await signIn(email, password);
    if (error) {
      setError(error.message);
    } else {
      onLogin(data.session);
    }
    setLoading(false);
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.logo}>
          <img src="/logo-dark.svg" alt="LogiConnect" style={{ width: '220px', marginBottom: '8px' }} />
        </div>
        <p style={styles.subtitle}>Plataforma logística</p>

        {error && (
          <div style={{ background: 'rgba(239,68,68,0.1)', border: '1px solid rgba(239,68,68,0.3)', borderRadius: '8px', padding: '12px', marginBottom: '16px', fontSize: '13px', color: '#ef4444', textAlign: 'center' }}>
            {error}
          </div>
        )}

        <form onSubmit={handleLogin} style={styles.form}>
          <div style={styles.field}>
            <label style={styles.label}>Correo electrónico</label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)}
              placeholder="tucorreo@empresa.com" style={styles.input} required />
          </div>
          <div style={styles.field}>
            <label style={styles.label}>Contraseña</label>
            <input type="password" value={password} onChange={e => setPassword(e.target.value)}
              placeholder="••••••••" style={styles.input} required />
          </div>
          <button type="submit" disabled={loading} style={{ ...styles.button, opacity: loading ? 0.7 : 1, cursor: loading ? 'not-allowed' : 'pointer' }}>
            {loading ? 'Iniciando sesión...' : 'Iniciar sesión'}
          </button>
          <p onClick={handleForgotPassword} style={styles.forgot}>¿Olvidaste tu contraseña?</p>
        </form>
      </div>
    </div>
  );
}

const styles = {
  container: { minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#0a0c10' },
  card: { background: '#111318', border: '1px solid #222730', borderRadius: '16px', padding: '48px 40px', width: '100%', maxWidth: '400px' },
  logo: { textAlign: 'center', marginBottom: '8px' },
  logoText: { fontSize: '36px', fontWeight: '700', color: '#00e5a0', letterSpacing: '2px' },
  logoTextWhite: { fontSize: '36px', fontWeight: '700', color: '#ffffff', letterSpacing: '2px' },
  subtitle: { textAlign: 'center', color: '#6b7280', fontSize: '13px', letterSpacing: '3px', textTransform: 'uppercase', marginBottom: '36px' },
  form: { display: 'flex', flexDirection: 'column', gap: '20px' },
  field: { display: 'flex', flexDirection: 'column', gap: '8px' },
  label: { fontSize: '13px', color: '#9ca3af', fontWeight: '500' },
  input: { background: '#181c24', border: '1px solid #222730', borderRadius: '8px', padding: '12px 16px', color: '#e8eaf0', fontSize: '14px' },
  button: { background: '#00e5a0', color: '#000000', border: 'none', borderRadius: '8px', padding: '14px', fontSize: '15px', fontWeight: '700', marginTop: '8px' },
  forgot: { textAlign: 'center', color: '#6b7280', fontSize: '13px', cursor: 'pointer' },
};